import TableRef from './TableRef';
import ViewRef from './ViewRef';

const isViewRef = (ref: unknown): ref is ViewRef =>
  Boolean((ref as ViewRef)._series);

class ColumnRef {
  constructor(
    readonly _table: TableRef | ViewRef,
    readonly _name: Nullable<string>,
  ) {}

  static buildFromServer(serverObj: ColumnRef) {
    return new ColumnRef(
      isViewRef(serverObj._table)
        ? ViewRef.build(serverObj._table)
        : TableRef.buildFromServer(serverObj._table),
      serverObj._name,
    );
  }

  /**
   * tov = TableRef or ViewRef
   */
  tov(): TableRef | ViewRef {
    return this._table;
  }

  name() {
    return this._name;
  }

  equals(c: Nullable<ColumnRef>) {
    if (!c) {
      return false;
    }

    if (!this.tov().equals(c.tov() as any)) {
      return false;
    }

    return this.name() === c.name();
  }

  toString() {
    return `${this.tov().uniqueName()}.${this.name()}`;
  }
}

export default ColumnRef;
